import React, { Component } from 'react'
import { connect } from "react-redux";
import { isLoggedIn } from "../../store/iam/selectors";

class AppWrapper extends Component {
  render() {
    return(
      <div className={`app-wrapper ${this.props.isLoggedIn?'has-mobile-navbar':null}`}>
        {this.props.children}
      </div>
    )
  }
}
const mapStateToProps = state => ({  
  isLoggedIn: isLoggedIn(state)  
});
 
export default connect(mapStateToProps,null)(AppWrapper);


 